<div class="page-content-wrapper">
  <app-sidebar-layout [showMenuToggle]="true">
    <div class="filter-forms-nav pages-title-nav p-0">
      <div class="container-fluid px-4">
        <div class="row align-items-center">
          <div class="calibration-details-title col-xs-12 col-sm-12 col-md-12 col-12 nav-colmn pl-0 ">
            <ul class="page-name-div calibration-name-list d-flex align-items-center">
              <a class="left-arrow" routerLink="/dashboard/devices/calibration-equipment">
                <span class="material-symbols-outlined purple-text pt-1 ">chevron_left</span>
              </a>
              <app-tab-main [links]="tabs"></app-tab-main>
              <span class="ml-auto d-flex" *objectHasPermission="permissionObject; action: editAction">
                <button class="btn btn-primary add-calibration-btn" (click)="openAddCalibrationPopup()">
                  {{ 'Add Calibration' | translate }}
                </button>
              </span>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="page-content-inner-wrap card-style-sec calibration-details-page-wrap custom-scrollbar">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-8 px-0">
            @if (overviewFields?.length) {
              <div class="col-md-12 card-col">
                <ng-container
                *ngTemplateOutlet="displaySection; context: { imageSrc: 'assets/images/equipment.svg', title: 'Calibration Overview', fields: overviewFields }"></ng-container>
              </div>
            }
            @if (maintenanceFields?.length) {
              <div class="col-md-12 card-col">
                <ng-container
                *ngTemplateOutlet="displaySection; context: { imageSrc: 'assets/images/sample-overview.svg', title: 'Maintenance Overview', fields: maintenanceFields }"></ng-container>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </app-sidebar-layout>
</div>

<ng-template #displaySection let-imageSrc="imageSrc" let-title="title" let-fields="fields">
  <h3 class="section-title">
    <img [src]="imageSrc" class="mr-1">
    {{ title | translate}}
  </h3>
  <div class="section">
    <div class="field-container">
      @for (field of fields; track trackByIndex($index)) {
        <div class="field">
          <div class="field-label">{{ field.label | translate }}</div>
          <div class="field-value">{{ field.value || '-' }}
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>